<template>
  <section class="banner">
    <div class="content-plane">
      <div class="container" style="position: relative;">
        <div>
          <div v-for="(slide, i) in slides" :key="`slide-banner-${i}`" :class="{ 'prepop': slide_index != i, 'd-none': slide_index != i && position > (100 / duration) * 2000 }" class="row cover border shadow-lg" :style="`background-image: url('${slide.imgpath}')`">
            <div class="label col-md-6" style="background-color: #000000a3 !important;">
              <div class="p-5 mb-4 rounded-3">
                <div class="container-fluid py-5">
                  <h2 class="display-7 fw-bold text-light" v-html="slide.title"></h2>
                  <p class="col-md-8 fs-4 text-muted" v-text="slide.subtitle"></p>
                  <Link class="btn btn-primary btn-lg" v-if="slide.url && slide.url[0] == '/'" :href="slide.url">Selengkapnya</Link>
                  <a class="btn btn-primary btn-lg" v-else-if="slide.url" :href="slide.url">Selengkapnya</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="indikator" :style="`width: ${position}%;`"></div>
      </div>

      <div class="d-flex justify-content-center align-items-center gap-4" style="height: 8em;">
        <span v-for="(slide, i) in slides" :key="`slide-${i}`" @click="setSlide(i)" class="cp pointer" :class="{ 'active': slide_index == i }"></span>
      </div>
    </div>
  </section>

  <section class="py-4">
    <div class="container">
      <div style="margin: 5em -1em; padding: 0">
        <div class="py-4">
          <ul class="nav nav-pills nav-fill">
            <li class="nav-item m-2">
              <a class="nav-link bg-success text-light" href="#">Infografis</a>
            </li>
            <li class="nav-item m-2">
              <a class="nav-link bg-success text-light" href="#">Pengumuman</a>
            </li>
            <li class="nav-item m-2">
              <a class="nav-link bg-success text-light" href="/geospasial" target="_blank">Peta Sebaran Industri</a>
            </li>
            <li class="nav-item m-2">
              <a class="nav-link bg-success text-light" href="#">Globally Harmonized System</a>
            </li>
          </ul>
        </div>
      </div>

      <div style="margin: 5em 0;">
        <div class="py-4">
          <h2 class="display-7">Cari Berdasarkan Kategori</h2>
        </div>

        <div class="row">
          <div class="col-md-4" v-for="(r, i) in penggunaan" :key="'kat-' + i">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title text-success py-4">
                  <Icon :icon="['fa', 'map-location-dot']" style="height: 3em" />
                </h5>
                <p class="card-text" v-text="r.urai"></p>
                <a href="#" class="card-link">{{ r.jumlah_matrix }} Titik</a>
                <a href="#" class="card-link">Lihat Map</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="postingan bg-white">
    <div class="container">
      <div style="padding: 5em 0;">
        <div class="py-4">
          <h2 class="display-7">Artikel Terbaru</h2>
        </div>

        <div class="row">
          <div class="col-md-6" v-for="(row, i) in postingan" :key="`postingan-${i}`">
            <div class="card shadow-lg border">
              <div class="card-body">
                <div class="p-4">
                  <h4>
                    <Link v-text="row.title" :href="`/postingan/${row.slug}`"></Link>
                  </h4>
                  <p class="text-muted">
                    <span v-text="(new Date(row.created_at)).toLocaleString()"></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <section class="py-4">
    <div class="container">
      <div style="margin: 5em 0 10em;">
        <img src="img/ARK_logo_blue.svg" alt="ARK Logo Blue" />

        <h1 class="display-4">Integritas dengan Ark Explorer</h1>

        <p>ARK atau Aliansi Riset Kebijakan Indonesia adalah suatu kajian kolektif terhadap data, dengan metode yang disempurnakan, dari berbagai alat serta pendekatan inovatif berbasis data untuk penyusunan kebijakan, disain/pemodelan, serta implementasi berdasarkan fakta</p>

        <a class="btn btn-outline-primary" href="http://arkdata.id/welcome" target="_blank" rel="noopener noreferrer">Pelajari lebih lanjut</a>
      </div>
    </div>
  </section>
</template>

<script>
import layout from '@/layout/Portal'
export default {
  layout,
  props: {
    postingan: Array,
    penggunaan: Array,
    slider: Array
  },
  data() {
    return {
      slides: [],
      slide_index: 0,

      navcollapse_show: false,
      navdropdown_show: false,

      position: 0,
      interval: false,
      duration: 6000
    }
  },
  methods: {
    slideShow() {
      this.interval = setInterval(() => {
        if(this.position < 100) {
          this.position +=  (100 / this.duration) * 15;
        } else {
          this.position = 0;
          this.nextSlide();
        }
      }, 15);
    },
    nextSlide() {
      if(this.slide_index < this.slides.length-1) {
        this.slide_index += 1;
      } else {
        this.slide_index = 0;
      }
    },
    setSlide(i) {
      this.slide_index = i;
      this.position = 0;
    }
  },
  mounted() {
    this.slides = this.slider;
    if(this.slides.length > 1) {
      this.slideShow();
    }
  },
  unmounted() {
    clearInterval(this.interval);
  }
}
</script>
